import { render, staticRenderFns } from "./penerimaanDetail.vue?vue&type=template&id=869e8cac&scoped=true"
import script from "./penerimaanDetail.vue?vue&type=script&lang=js"
export * from "./penerimaanDetail.vue?vue&type=script&lang=js"
import style0 from "./penerimaanDetail.vue?vue&type=style&index=0&id=869e8cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e8cac",
  null
  
)

export default component.exports